
import React from 'react';
import { cn } from '@/lib/utils';
import { NavItem } from '../types';
import NavItemButtonContent from './NavItemButtonContent';
import ChildNavItem from './ChildNavItem';
import { 
  Collapsible,
  CollapsibleTrigger,
  CollapsibleContent
} from '@/components/ui/collapsible';

interface SubMenuProps {
  item: NavItem;
  expanded: boolean;
  isMobile: boolean;
  isExpanded: boolean;
  isChildActive: boolean;
  badgeCount: number | null;
  toggleExpandItem: (title: string, event: React.MouseEvent) => void;
  handleNavigation: () => void;
}

const SubMenu: React.FC<SubMenuProps> = ({
  item,
  expanded,
  isMobile,
  isExpanded,
  isChildActive,
  badgeCount,
  toggleExpandItem,
  handleNavigation
}) => {
  const Icon = item.icon;
  
  return (
    <Collapsible
      open={isExpanded}
      onOpenChange={() => {}}
      className="space-y-1"
    >
      <CollapsibleTrigger asChild>
        <button
          onClick={(e) => toggleExpandItem(item.title, e)}
          className={cn(
            "flex items-center w-full px-3 py-2.5 rounded-md transition-colors duration-200 group relative",
            isChildActive ? "text-primary font-medium" : "text-muted-foreground",
            "hover:bg-muted hover:text-foreground"
          )}
        >
          <NavItemButtonContent
            title={item.title}
            Icon={Icon}
            expanded={expanded}
            isMobile={isMobile}
            badgeCount={badgeCount}
            isExpanded={isExpanded}
          />
        </button>
      </CollapsibleTrigger>
      
      <CollapsibleContent className="pl-8 space-y-1">
        {item.children && item.children.map((child) => (
          <ChildNavItem
            key={child.path}
            child={child}
            handleNavigation={handleNavigation}
          />
        ))}
      </CollapsibleContent>
    </Collapsible>
  );
};

export default SubMenu;
